import { render } from "./CascoViolationLetter.vue?vue&type=template&id=db4355c0&scoped=true"
import script from "./CascoViolationLetter.vue?vue&type=script&lang=js"
export * from "./CascoViolationLetter.vue?vue&type=script&lang=js"

import "./CascoViolationLetter.vue?vue&type=style&index=0&id=db4355c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db4355c0"]])

export default __exports__